import { CancelOutlined } from "@mui/icons-material";
import React, { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import NumberFormat from "react-number-format";
import Modal from "react-responsive-modal";
import { devLog } from "utils/devLog";
export default function CustomerInfo(props) {
  const { t } = useTranslation();

  const [partner, setPartner] = useState(props?.currState?.partner);
  const [isSearsTransformco, setIsSearsTransformco] = useState(
    props?.currState?.appConfig?.subPartnerName === "Sears Transformco",
  );

  const [firstName, setFirstName] = useState(props.customerInfoObj.firstName);
  const [lastName, setLastName] = useState(props.customerInfoObj.lastName);
  const [number, setNumber] = useState(props.customerInfoObj.number);
  const [policyNumber, setPolicyNumber] = useState(props.customerInfoObj.policyNumber);
  const [companyName, setCompanyName] = useState(
    isSearsTransformco ? "Sears Transformco" : props.customerInfoObj.companyName,
  );
  const [country, setCountry] = useState(props.customerInfoObj.country);
  const [driverNumber, setDriverNumber] = useState(props.customerInfoObj.driverNumber);

  const [enablePolicyNumber, setEnablePolicyNumber] = useState(props.enablePolicyNumber);
  const [numberError, setNumberError] = useState(false);
  const [driverNumberError, setDriverNumberError] = useState(false);

  useEffect(() => {
    setPartner(props?.currState?.partner);
  }, [props?.currState?.partner]);

  function capitalize(str) {
    str = str.toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function onSubmit(e) {
    e.preventDefault();
    const callbackInvalid = !checkPhoneNumberLength(number);
    const driverInvalid = isSearsTransformco && !checkPhoneNumberLength(driverNumber);
    if (callbackInvalid) setNumberError(true);
    if (driverInvalid) setDriverNumberError(true);
    if (callbackInvalid || driverInvalid) {
      return;
    }

    const loadData = {
      FirstName: firstName.trim().toUpperCase(),
      LastName: lastName.trim().toUpperCase(),
      Number: number,
      PolicyNumber: policyNumber,
      companyName: companyName,
      driverNumber: driverNumber,
      country: country,
    };

    if (typeof props.onUserNext === "function") {
      props.onUserNext(loadData);
    }
  }

  useEffect(() => {
    setFirstName(props.customerInfoObj.firstName);
    setLastName(props.customerInfoObj.lastName);
    setNumber(props.customerInfoObj.number);
    setPolicyNumber(props.customerInfoObj.policyNumber);
    setCompanyName(props.customerInfoObj.companyName);
    setCountry(props.customerInfoObj.country);
    setDriverNumber(props.customerInfoObj.driverNumber);
    setIsSearsTransformco(props?.currState?.appConfig?.subPartnerName === "Sears Transformco");
  }, [props.customerInfoObj]);

  useEffect(() => {
    setEnablePolicyNumber(!!props.enablePolicyNumber);
  }, [props.enablePolicyNumber]);

  const driverFirstName = isSearsTransformco
    ? t("description.ConfirmDriverFirstName")
    : t("description.ConfirmCustomerFirstName");
  const driverLastName = isSearsTransformco
    ? t("description.ConfirmDriverLastName")
    : t("description.ConfirmCustomerLastName");
  const driverNumberLabel = isSearsTransformco
    ? t("description.ConfirmDriverNumber")
    : t("description.ConfirmCustomerPrimaryContactNumber1");

  const checkPhoneNumberLength = (phoneNumber) => {
    if (!phoneNumber) {
      return false;
    }
    phoneNumber = phoneNumber.replace(/\D/g, "");
    devLog("phoneNumber length", phoneNumber.length);
    return phoneNumber.length === 10;
  };
  return (
    <div className="formContainer">
      <form onSubmit={onSubmit} className="form">
        <div className="group-1">
          <div className="label">{driverFirstName}:</div>
          <input
            type="text"
            placeholder="ex: JOHN"
            id="fname"
            name="fname"
            className="input form-control required"
            value={firstName}
            onChange={(e) => {
              setFirstName(e.target.value.toUpperCase());
            }}
            required
          />
        </div>
        <div className="group-1">
          <div className="label">{driverLastName}:</div>
          <input
            type="text"
            placeholder="ex: DOE"
            id="lname"
            name="lname"
            className="input form-control required"
            value={lastName}
            onChange={(e) => {
              setLastName(e.target.value.toUpperCase());
            }}
            required
          />
        </div>
        <div className="group-1">
          <div className="label">{driverNumberLabel}:</div>

          <NumberFormat
            placeholder={t("description.ConfirmCustomerPrimaryContactNumber2")}
            id="phone"
            name="phone"
            className="input form-control required"
            value={isSearsTransformco ? driverNumber : number}
            format={"(###)-###-####"}
            mask="_"
            onChange={(e) => {
              isSearsTransformco ? setDriverNumberError(false) : setNumberError(false);
              isSearsTransformco ? setDriverNumber(e.target.value) : setNumber(e.target.value);
            }}
            style={{
              borderColor: (isSearsTransformco ? driverNumberError : numberError) ? "#d32f2f" : "#aaa",
            }}
            required
          />
        </div>

        {partner === "PBFL" && (
          <>
            <div className="group-1">
              <div className="label">{t("description.ConfirmCustomerCompanyName")}:</div>
              <input
                type="text"
                placeholder="ex: ABC Company"
                id="companyName"
                name="companyName"
                className="input form-control required"
                value={companyName}
                onChange={(e) => {
                  setCompanyName(e.target.value.toUpperCase());
                }}
                required
                disabled={isSearsTransformco}
              />
            </div>
          </>
        )}

        {isSearsTransformco && (
          <div className="group-1">
            <div className="label">Callback Number:</div>
            <NumberFormat
              placeholder={t("description.ConfirmCustomerPrimaryContactNumber2")}
              id="phone"
              name="phone"
              className="input form-control required"
              value={number}
              format={"(###)-###-####"}
              mask="_"
              onChange={(e) => {
                setNumberError(false);
                setNumber(e.target.value);
              }}
              style={{ borderColor: numberError ? "#d32f2f" : "#aaa" }}
              required
            />
          </div>
        )}

        {enablePolicyNumber ? (
          <div className="group-1">
            <div className="label">{t("description.ConfirmCustomerPolicyNumber1")}:</div>
            <NumberFormat
              placeholder={t("description.ConfirmCustomerPolicyNumber2")}
              id="policyNumber"
              name="policyNumber"
              className="input form-control required"
              value={policyNumber}
              onChange={(e) => {
                setPolicyNumber(e.target.value);
              }}
              required
            />
          </div>
        ) : (
          <></>
        )}

        <Modal
          className={`policy-loader-modal`}
          open={numberError || driverNumberError}
          onClose={() => {
            setNumberError(false);
            setDriverNumberError(false);
          }}
        >
          <h2 style={{ marginTop: 30 }}>{t("description.EnterValidPhoneNumber")}</h2>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
            <button
              type="button"
              className="ui-btn"
              onClick={() => {
                setNumberError(false);
                setDriverNumberError(false);
              }}
            >
              OK
            </button>
          </div>
        </Modal>

        <div className="footerContainer" style={{ display: "flex" }}>
          <div>
            <button
              id="cancelButton"
              type="button"
              className="footer"
              style={{ background: "#f4f4f4", color: "black", paddingLeft: 14 }}
              onClick={(e) => {
                e.preventDefault();
                devLog("UI Cancel pressed");
                if (typeof props.onUserCancel === "function") {
                  props.onUserCancel();
                }
              }}
            >
              <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
              <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
            </button>
          </div>
          <div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
